import { render, staticRenderFns } from "./endJoin.vue?vue&type=template&id=7646e648&scoped=true&"
import script from "./endJoin.vue?vue&type=script&lang=js&"
export * from "./endJoin.vue?vue&type=script&lang=js&"
import style0 from "./endJoin.vue?vue&type=style&index=0&id=7646e648&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7646e648",
  null
  
)

export default component.exports